import React from 'react';
export function EstoEsParaVosSection() {
  return <section className="relative w-full text-white" style={{
    backgroundImage: "url('https://res.cloudinary.com/dd0wtuekk/image/upload/v1771285256/Kk_rxxiy7.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '60px 20px'
  }} data-id="element-47">
      {/* Dark overlay */}
      <div className="absolute inset-0" style={{
      background: 'rgba(0,0,0,0.65)'
    }} data-id="element-48" />

      <div className="relative z-10 max-w-[600px] mx-auto" data-id="element-49">
        <h2 className="font-extrabold text-center" style={{
        fontSize: '22px',
        marginBottom: '24px'
      }} data-id="element-50">
          ESTO ES PARA TI SÍ…
        </h2>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[500]" data-id="element-51">
          ❌ Te duele verlo{' '}
          <span style={{
          color: 'red'
        }} className="font-[800]" data-id="element-52">
            paralizarse en los partidos
          </span>
          … sabiendo que le sobra el talento.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-53">
          ❌ Te duele verlo{' '}
          <span style={{
          color: 'red'
        }} className="font-[800]" data-id="element-54">
            jugar con miedo y esconderse
          </span>{' '}
          cuando más importa.
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-55">
          ❌ Te preocupa ver que otros avanzan… mientras el tuyo{' '}
          <span style={{
          color: 'red'
        }} className="font-[800]" data-id="element-56">
            se queda atrás por falta de confianza.
          </span>
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-57">
          ❌ Sabes que entrena y se esfuerza… pero en el partido{' '}
          <span style={{
          color: 'red'
        }} className="font-[800]" data-id="element-58">
            la cabeza lo traiciona.
          </span>
        </p>

        <p style={{
        marginBottom: '18px',
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-59">
          ❌ Te da miedo{' '}
          <span style={{
          color: 'red'
        }} className="font-[800]" data-id="element-60">
            que piense que no es lo suficientemente bueno.
          </span>
        </p>

        <p style={{
        lineHeight: 1.6,
        fontSize: '15px'
      }} className="font-[600]" data-id="element-61">
          ❌ Da todo entrenando… y en el partido{' '}
          <span style={{
          color: 'red'
        }} className="font-[800]" data-id="element-62">
            no puede demostrarlo
          </span>
          . Y eso duele.
        </p>
      </div>
    </section>;
}